import auth from "./auth.json";
import main from "./main.json";
import modals from "./modals.json";
import formValidation from "./validation.json";

const locale = {
  auth,
  formValidation,
  modals,
  main,
};

const frLocale = locale; // Simplifies copy paste... every locale index is the same

export default frLocale;
